import { create, tsx } from '@dojo/framework/core/vdom';
import { Link, LinkProperties } from '@dojo/framework/routing/Link';
import * as css from './LinkButton.m.css';

export interface LinkButtonProperties {
	/**
	 * undefined: use on light colored backgrounds;
	 * on-dark: use on dark colored backgrounds;
	 * on-medium: use on medium colored backgrounds
	 */
	color?: 'on-dark' | 'on-medium';
	to?: string;
	params?: LinkProperties['params'];
	title?: string;
	target?: string;
	rel?: string;
	href?: string;
	tabIndex?: number;
	responsive?: boolean;
	size?: 'smaller';
}

const factory = create().properties<LinkButtonProperties>();

export const LinkButton = factory(function LinkButton({ properties, children }) {
	const {
		color,
		to,
		params,
		title,
		rel,
		target,
		href,
		tabIndex,
		responsive = false,
		size
	} = properties();
	const classes = [
		css.button,
		color === 'on-dark' && css.onDark,
		color === 'on-medium' && css.onMedium,
		responsive && css.responsive,
		size === 'smaller' && css.smaller
	];

	const attributes = {
		params,
		title,
		rel,
		target,
		classes,
		tabIndex
	};

	if (to) {
		return (
			<Link to={to} {...attributes}>
				{children()}
			</Link>
		);
	} else if (href) {
		return (
			<a href={href} {...attributes}>
				{children()}
			</a>
		);
	}
});

export default LinkButton;
